import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';

import { Button } from '@eventbrite/eds-button';
import { AlertChunky } from '@eventbrite/eds-iconography';
import { AuthLibSecurity } from '@eventbrite/auth-lib';

import ModalMessage from '../ModalMessage';
import { TEXT_LIMIT_RETRY_TIME } from '../../constants/messages';
import './PasswordlessLimitReached.scss';

const PasswordlessLimitReached = ({ email, onClick }) => {
    const componentClasses = classNames(
        'eds-l-mar-vert-14 passwordless-email-status',
    );

    const headerText = gettext(
        'You made more than 5 requests to send a login link to',
    );
    const subtitleText = `${AuthLibSecurity.ofuscateEmail({ email })}`;

    const buttonText = gettext('Go to Log in');
    const buttonEvent = onClick;

    return (
        <div className={componentClasses}>
            <ModalMessage
                iconType={<AlertChunky />}
                headerText={headerText}
                subtitleText={subtitleText}
                expirationTimeText={TEXT_LIMIT_RETRY_TIME}
            />

            <div className="eds-l-pad-top-8 eds-align--center">
                <Button
                    style="link"
                    onClick={buttonEvent}
                    data-testid="passwordless-ok-button"
                    __containerClassName="passwordless-form__button--grey"
                >
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};

PasswordlessLimitReached.propTypes = {
    email: PropTypes.string,
};

export default PasswordlessLimitReached;
